module.exports = __webpack_public_path__ + "img/leveler-4-off.a7265061.png";